import { gql } from '@apollo/client';

export default gql`
  query cheapestFaresSearch(
    $numberOfPassenger: Int
    $mainPassengerType: MainPassengerType
    $passengersList: [MainPassengerType]
    $productFamiliesSearch: [String!]
    $contractCodeSearch: String
    $currency: Currency!
    $cheapestFaresLists: [CheapestFaresList!]!
    $isTotalPriceSearch: Boolean
  ) {
    cheapestFaresSearch(
      mainPassengerType: $mainPassengerType
      numberOfPassenger: $numberOfPassenger
      productFamiliesSearch: $productFamiliesSearch
      contractCodeSearch: $contractCodeSearch
      currency: $currency
      cheapestFaresLists: $cheapestFaresLists
      passengersList: $passengersList
      isTotalPriceSearch: $isTotalPriceSearch
    ) {
      cheapestFares {
        date
        price
      }
    }
  }
`;
